
<router-outlet></router-outlet>
<ng-container *ngIf="!isBk">
    <ng-container *ads="true; pos 'in_body'"></ng-container>
</ng-container>

